import { Button, Checkbox, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, IconButton, TextField, Tooltip } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useLazyGetNewTokenQuery } from '../../../store/data/dataSlice';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: ()=>void;
}

const NewTokenDialog = ({open, onClose}: Props) => {
    const [checked, setChecked] = useState(false);
    const [token, setToken] = useState("");
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [ getToken, newToken ] = useLazyGetNewTokenQuery();
    const { t } = useTranslation();

    useEffect(() => {
        if(newToken.data) {
            setToken(newToken.data);
        }
    }, [newToken])

    const onGenerate = () => {
        getToken();
    }

    const handleChange = () => {
        const currentChecked = checked;
        setChecked(!currentChecked);
    }

    const handleTooltipClose = () => {
        setTooltipOpen(false);
      };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={'lg'}>
        <DialogTitle>
        <Trans>Generate new token</Trans>
        </DialogTitle>
        <DialogContent>
            <DialogContentText marginBottom={2}>
            <Trans>To use this site correctly you need a generated usertoken.</Trans>
            </DialogContentText>
            <DialogContentText marginBottom={2}>    
            <Trans>You will need to enter it on the previous dialog if you are logged out. (E.g. you are using this website from a different device or using a different browser)</Trans>
            </DialogContentText>
            <DialogContentText marginBottom={2}>  
            <Trans>If you do not have a token yet you can create a new one here.</Trans>
            </DialogContentText>
            <DialogContentText>  
            <Trans>IMPORTANT: The token is NOT recoverable, if you lose it you will lose any progress associated with it. Make sure to save it locally or write it down.</Trans>
            </DialogContentText>
            <FormControlLabel
                control={<Checkbox checked={checked} onChange={handleChange}/>} label={<Trans>I am aware that this token cannot be recovered and have made a copy of it.</Trans>}
            />
            <TextField
                margin='normal'
                id="tokentf"
                label={<Trans>Usertoken</Trans>}
                value={token}
                type="token"
                fullWidth
                variant="outlined"
                disabled={true}
                InputProps={{endAdornment:
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                        <div>
                            <Tooltip
                              PopperProps={{
                                disablePortal: true,
                              }}
                              onClose={handleTooltipClose}
                              open={tooltipOpen}
                              disableFocusListener
                              disableHoverListener
                              disableTouchListener
                              title={<Trans>Copied to clipboard!</Trans>}
                            >
                                <IconButton onClick={() => {
                                    if(newToken.data) {
                                        navigator.clipboard.writeText(newToken.data);
                                        setTooltipOpen(true);
                                    }
                                }}>
                                    <ContentCopyIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </ClickAwayListener>
                }}
            />
            <Button disabled={!checked} variant={'contained'} color={'success'} onClick={onGenerate}>
            <Trans>Generate</Trans>
            </Button>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}><Trans>Close</Trans></Button>
        </DialogActions>
    </Dialog>
  )
}

export default NewTokenDialog